import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "w-full" }
const _hoisted_2 = { class: "bg-primary-100" }
const _hoisted_3 = ["width"]
const _hoisted_4 = {
  key: 0,
  class: "px-6 py-2 text-xs font-semibold text-center text-neutral-900 whitespace-nowrap"
}
const _hoisted_5 = { class: "text-sm text-gray-500 bg-white divide-y divide-gray-200" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = ["colspan"]
const _hoisted_8 = { class: "py-4 text-sm text-gray-400" }

import { ChevronUpDownIcon } from "@heroicons/vue/24/outline";


export default /*#__PURE__*/_defineComponent({
  __name: 'DataTable',
  props: {
    modelValue: {
        default: null,
        required: true,
    },
    headers: {
        default: null,
        type: String
    },
    parentTableClass: {
        default: null,
        type: String
    },
    tableClass: {
        default: null,
        type: String
    },
    dataTableClass: {
        default: null,
        type: String
    },

    haveSort: {
        default: false,
        type: Boolean
    },

    /* Text for empty list */
    emptyText: {
        default: 'No data to display.',
        type: String
    },

    /* Hide action column */
    noAction: {
        default: false,
        type: Boolean
    },

    /* Action header text */
    actionText: {
        default: 'Actions',
        type: String
    },

    count: {
        default: 0,
        type: Number,
    },

},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["frm-table", [ __props.dataTableClass ]])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass([__props.parentTableClass, "overflow-auto"])
      }, [
        _createElementVNode("table", {
          class: _normalizeClass(["min-w-full divide-y divide-gray-200", [ __props.tableClass ]])
        }, [
          _renderSlot(_ctx.$slots, "header", {}, () => [
            _createElementVNode("thead", _hoisted_2, [
              _createElementVNode("tr", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.headers, (header, index) => {
                  return (_openBlock(), _createElementBlock("th", {
                    key: `th-${index}`,
                    class: "px-6 py-[25px] text-left text-xs text-neutral-900 font-semibold whitespace-nowrap th-parent",
                    width: header.width
                  }, [
                    _createElementVNode("span", null, _toDisplayString(header.text), 1),
                    (header.haveSort)
                      ? (_openBlock(), _createBlock(_unref(ChevronUpDownIcon), {
                          key: 0,
                          class: "inline-block w-5 h-5 ml-2 cursor-pointer text-neutral-900"
                        }))
                      : _createCommentVNode("", true)
                  ], 8, _hoisted_3))
                }), 128)),
                (!__props.noAction)
                  ? (_openBlock(), _createElementBlock("th", _hoisted_4, _toDisplayString(__props.actionText), 1))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("tbody", _hoisted_5, [
            (__props.count > 0)
              ? _renderSlot(_ctx.$slots, "body", { key: 0 })
              : (_openBlock(), _createElementBlock("tr", _hoisted_6, [
                  _createElementVNode("td", {
                    class: "text-center whitespace-nowrap",
                    colspan: 
                                        __props.headers.length + (!__props.noAction ? 1 : 0)
                                    
                  }, [
                    _createElementVNode("div", _hoisted_8, _toDisplayString(__props.emptyText), 1)
                  ], 8, _hoisted_7)
                ]))
          ])
        ], 2)
      ], 2),
      _renderSlot(_ctx.$slots, "tfoot")
    ])
  ], 2))
}
}

})